import React from "react";
import Dialog from "../../../shared/dialog";
import MyButton from "../../../shared/buttons/primary";
import "./index.scss";

const UnblockedSeatModal = (props) => {
  const { onClose, onAccept } = props;

  return (
    <Dialog
      id="confirm-dialog"
      className={"confirm-dialog"}
      isShow={true}
      onCloseRequest={onClose}
      closeOnOverlayClick={true}
    >
      <h2 className="text-center">
        この時間枠のステータスを『未予約』に変更しますか？
      </h2>
      <div className="booking-form__btns">
        <MyButton className="me-1" myVariant="cancel" onClick={onClose}>
          いいえ
        </MyButton>
        <MyButton myVariant="accept" onClick={onAccept}>
          はい
        </MyButton>
      </div>
    </Dialog>
  );
};

export default React.memo(UnblockedSeatModal);
